import { render, staticRenderFns } from "./PatreonSyncs.vue?vue&type=template&id=034a4b8c&scoped=true"
import script from "./PatreonSyncs.vue?vue&type=script&lang=js"
export * from "./PatreonSyncs.vue?vue&type=script&lang=js"
import style0 from "./PatreonSyncs.vue?vue&type=style&index=0&id=034a4b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a4b8c",
  null
  
)

export default component.exports